import * as React from 'react'
import '../styles/App.scss'
import '../styles/NumberOfItems.scss'
import { JobItems } from '../types'
import images from '../images'
import { SubCategoryNames } from '../constants/subCategoryNames'
import { JobSubCategory } from '../types/jobCategories'

import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

interface NumberOfItemsProps {
  onNumberOfBags: (numberOfBags) => void,
  setAmount: (amount: number) => void,
  removeAllImages: () => void
  subCategories: Array<any>,
  jobItems: JobItems[]
  amount: number
}

interface NumberOfItemsState {
  subCategories: JobSubCategory[]
}

export default class NumberOfItems extends React.Component<NumberOfItemsProps, NumberOfItemsState> {
  constructor(props: NumberOfItemsProps) {
    super(props)
    this.state = {
      subCategories: this.props.subCategories
    }
  }

  componentDidMount() {
    this.props.subCategories && this.props.subCategories.map((subCategory: JobSubCategory) => {
      this.setState(prevState => {
        let jobItem = this.props.jobItems !== null ?
          this.props.jobItems.find(jobItem => jobItem.subCategoryId === subCategory.name) : undefined
        return { ...prevState, [subCategory.name]: jobItem ? jobItem.count : 0 }
      })
    })
    this.props.removeAllImages()
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props.subCategories !== nextProps.subCategories) {

      this.props.subCategories.map((subCategory) => {
        this.setState(prevState => {
          return { ...prevState, [subCategory.name]: 0 }
        })
      })

      if (nextProps.subCategories && nextProps.subCategories.length > 1) {
        this.setState({
          subCategories: nextProps.subCategories
        })

        nextProps.subCategories.map((subCategory) => {
          this.setState(prevState => {
            return { ...prevState, [subCategory.name]: prevState[subCategory.name] ? prevState[subCategory.name] : 0 }
          })
        })

        let amount = this.resetAmount(nextProps)
        let numberOfBags = this.reset(nextProps)
        this.props.onNumberOfBags(numberOfBags)
        this.props.setAmount(amount)
      }
    }
  }

  reset = (props: NumberOfItemsProps) => {
    let numberOfBags: Array<any> = []
    props.subCategories.map((subCategory: JobSubCategory) => {
      numberOfBags.push({
        subCategoryId: subCategory.name,
        count: this.state[subCategory.name] ? this.state[subCategory.name] : 0
      })
    })
    return numberOfBags
  }

  resetAmount = (props: NumberOfItemsProps) => {
    let amount = 0
    props.subCategories.map((subCategory: JobSubCategory) => {
      amount += this.state[subCategory.name] * Number(subCategory.price)
    })
    return amount
  }

  setSubCategoryImage(name: string) {
    switch (name) {
      case SubCategoryNames.BIG:
        return images.bigBag
      case SubCategoryNames.SMALL:
        return images.smallBag
    }
    return images.smallBag
  }

  handleBagsNumberChange(event, name: string) {
    event.persist()
    this.setState(prevState => {
      let count = Number(event.target.value) >= 20 ? 20 : Number(event.target.value)

      let amount = this.calculateAmount(name, count - prevState[name])
      let numberOfBags = this.calculateNumberOfBags(name, count)

      this.props.setAmount(amount)
      this.props.onNumberOfBags(numberOfBags)

      return { ...prevState, [name]: count }
    })
  }

  changeItemNumber(event, name: string) {
    event.persist()
    let count: number
    let amount: number
    let numberOfBags
    this.setState(prevState => {
      if (event.target.name === 'plus') {
        count = prevState[name] >= 20 ? 20 : prevState[name] + 1
      } else {
        count = prevState[name] <= 0 ? 0 : prevState[name] - 1
      }
      amount = this.calculateAmount(name, count - prevState[name])
      numberOfBags = this.calculateNumberOfBags(name, count)
      this.props.setAmount(amount)
      this.props.onNumberOfBags(numberOfBags)

      return { ...prevState, [name]: count, amount: amount }
    })
  }

  calculateAmount(name: string, count: number) {
    let amount
    let tempAmount = this.props.amount ? this.props.amount : 0
    this.state.subCategories.map((subCategory: JobSubCategory) => {
      if (name === subCategory.name) {
        amount = tempAmount + count * Number(subCategory.price)
      }
    })
    return amount
  }

  calculateNumberOfBags(name?: string, count?: number) {
    let numberOfBags: JobItems[] = []
    this.state.subCategories.map((subCategory: JobSubCategory) => {
      numberOfBags.push({
        subCategoryId: subCategory.name,
        count: count === undefined ? 0 : name === subCategory.name ? count : this.state[subCategory.name]
      })
    })
    return numberOfBags
  }

  render() {
    return (
      <div className="Pickup-info" >
        <div className="title">{StringResources.getString(Strings.Components.NumberOfItems.Title)}</div>
        {
          this.state.subCategories && this.state.subCategories.length !== 0 ?
            <div className="category-list scrollable count-based">
              <PerfectScrollbar className="horizontal-scroll">
                {
                  this.state.subCategories.map((subCategory, index) => (
                    <div key={subCategory.id} className="sub-category-item">
                      <div className='border-container'>
                      <div className='junk-icon' >
                        <img src={this.setSubCategoryImage(subCategory.name)} />
                        <p>
                          {subCategory.name}
                        </p>
                      </div>
                      <input
                        type="number"
                        min={0}
                        className="number-of-items"
                        value={this.state[subCategory.name] ? this.state[subCategory.name] : 0}
                        // tslint:disable-next-line:jsx-no-lambda
                        onChange={event => this.handleBagsNumberChange(event, subCategory.name)}
                      />
                      <ul className="buttons">
                        <li>
                          <button
                            className="plus-button"
                            name="plus"
                            // tslint:disable-next-line:jsx-no-lambda
                            onClick={(event) => this.changeItemNumber(event, subCategory.name)}
                          >
                            +
                          </button>
                        </li>
                        <li>
                          <button
                            className="minus-button"
                            name="minus"
                            // tslint:disable-next-line:jsx-no-lambda
                            onClick={(event) => this.changeItemNumber(event, subCategory.name)}
                          >
                            -
                          </button>
                        </li>
                      </ul>
                      </div>
                    </div>
                  ))
                }
              </PerfectScrollbar>
            </div> : null
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NumberOfItems.tsx